import { Component, inject, Output, EventEmitter, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { TenantService } from '../../../shared/services/tenant.service';
import { Tenant } from '../../../shared/models/user.model';
import { CommonModule } from '@angular/common';
import type { Schema } from '../../../../../amplify/data/resource';
import { generateClient } from 'aws-amplify/data';

const client = generateClient<Schema>();

@Component({
  selector: 'app-add-employee',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './add-employee.html',
})
export class AddEmployeeComponent implements OnInit {
  private tenantService = inject(TenantService);
  private fb = inject(FormBuilder);

  @Output() close = new EventEmitter<void>();

  showSuccess = signal(false);
  successEmail = signal('');
  error = signal<string | null>(null);
  isSubmitting = signal(false);
  tenants: Tenant[] = [];

  readonly form: FormGroup = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    tenantId: ['', Validators.required]
  });

  async ngOnInit() {
    this.tenants = await this.tenantService.listTenants();
    if (this.tenants.length > 0) {
      this.form.patchValue({ tenantId: this.tenants[0].id });
    }
  }

  async onSubmit(event: Event) {
    event.preventDefault();
    this.error.set(null);

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.error.set('Please fill in all required fields');
      return;
    }

    this.isSubmitting.set(true);

    try {
      const { email, firstName, lastName, tenantId } = this.form.getRawValue();

      await client.mutations.AdminInviteUser({
        email,
        tenantId,
        firstName,
        lastName
      });

      // Show success message
      this.successEmail.set(email);
      this.showSuccess.set(true);

      // Reset form
      this.form.reset({
        tenantId: this.tenants[0]?.id || ''
      });

      // Auto-close after 3 seconds
      setTimeout(() => {
        this.closeModal();
      }, 3000);

    } catch (err: any) {
      console.error('Error inviting user:', err);
      this.error.set(err.message || 'Error while inviting user. Please try again.');
    } finally {
      this.isSubmitting.set(false);
    }
  }

  closeModal() {
    this.showSuccess.set(false);
    this.error.set(null);
    this.close.emit();
  }
}
